import {createModelSchema, alias} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";


export class SmartOfferBundleRewardGiver extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.REWARD_GIVER);

        this._rewardTrack = null;
        this._currency = null;
        this._reward = null;
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (this.rewardTrack && !this.rewardTrack.valid()) {
            console.log("RG1");
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            console.log("RG2")
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            console.log("RG3")
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.rewardTrack || this.rewardTrack.empty()) {
            return true;
        }

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleRewardGiver());
        } else if (target instanceof SmartOfferBundleRewardGiver) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleRewardGiver, {
    _rewardTrack: alias("reward_track", RewardTrack.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _reward: alias("reward", RewardBunch.schema())
});
